<template>
  <div class="left-menu mobile-modal">
    <div class="reserve-tickets">
      <div class="left-menu__top">
        <p class="mobile-modal-title text-uppercase">Book Experience</p>
        <button class="btn left-menu__close" @click.stop="close">
          <TheCrossIcon />
        </button>
      </div>

      <div class="d-flex flex-column justify-content-between h-100">
        <div class="left-menu__body">
          <div class="variant variant-radio active">
            <span class="variant__text">Join the waitlist</span>
          </div>
        </div>
        <form class="note w-100">
          <div class="d-flex h-100">
            <span class="note__label small-grey text-nowrap">Notes</span>
            <textarea
              v-model="notes"
              class="w-100 notes h-100"
              :maxlength="notesFieldMaxlength"
              placeholder="Please fill any other relevant notes here"
            />
          </div>
        </form>
      </div>

      <div class="reserve-tickets__request btn-bottom">
        <AppSeparatorLine />
        <button class="btn" @click.stop="requestTickets">
          <span>Join the waitlist</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ERR_DEFAULT_MSG } from '@/helpers/errorHandler';
import { SF_CASE_INSTRUCTIONS_MAXLENGTH } from '@/helpers/formFields';
import TheCrossIcon from '@/components/icons/TheCrossIcon.vue';
import AppSeparatorLine from '@/components/AppSeparatorLine.vue';
import joinExperienceWaitlistMutation from '@/graphql/booking/JoinExperienceWaitlist.mutation.gql';
import TheCheckedMarkIcon from '@/components/icons/TheCheckedMarkIcon.vue';

export default {
  name: 'AppJoinWaitlistForm',
  components: { TheCheckedMarkIcon, TheCrossIcon, AppSeparatorLine },

  props: {
    experienceId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      notes: '',
      isMobile: window.innerWidth < 768,
      notesFieldMaxlength: SF_CASE_INSTRUCTIONS_MAXLENGTH,
    };
  },

  created() {
    if (this.isMobile) {
      this.$store.dispatch('disableScroll');
    }
  },

  methods: {
    close() {
      this.$emit('close');

      if (this.isMobile) {
        this.$store.dispatch('enableScroll');
      }
    },

    requestTickets() {
      this.$emit('show-loader');

      this.$apollo
        .mutate({
          mutation: joinExperienceWaitlistMutation,
          variables: {
            experienceId: this.experienceId,
            notes: this.notes || null,
          },
        })
        .then(({ data }) => {
          if (data?.joinExperienceWaitlist) {
            this.$toast.success(data.joinExperienceWaitlist.message);
            this.$emit('hide-loader');
            this.$emit('close');
          }
        })
        .catch((err) => {
          this.$emit('hide-loader');
          this.$toast.error(err?.graphQLErrors?.[0]?.message || ERR_DEFAULT_MSG);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

form {
  height: 150px;
}

.notes {
  border: 0;
  color: vars.$c-dark-gray;

  &::placeholder {
    font-weight: 400;
  }
}
</style>
